import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
export var image = function image() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$isDefault = _ref2.isDefault,
    isDefault = _ref2$isDefault === void 0 ? false : _ref2$isDefault;
  return /*#__PURE__*/css("position:relative;text-align:center;display:inline-block;width:128px;height:126px;float:left;", isDefault && /*#__PURE__*/css("background-color:", variables.colour.neutral100, ";color:", variables.colour.neutral500, ";height:126px;"));
};
var _ref = {
  name: "578io7",
  styles: "margin-top:30%;"
};
export var square = function square() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$isDefault = _ref3.isDefault,
    isDefault = _ref3$isDefault === void 0 ? false : _ref3$isDefault;
  return /*#__PURE__*/css("display:inline-block;width:100%;", !isDefault && /*#__PURE__*/css("height:100%;object-fit:cover;background-color:", variables.colour.neutral50, ";"), " ", isDefault && _ref);
};
export var text = /*#__PURE__*/css("font-family:", variables.font.bodyFontFamily, ";font-size:", variables.font.smallFontSize, ";");